module.exports = __webpack_public_path__ + "img/21+1_大腸簡圖.890b3c13.png";